import { Injectable } from '@angular/core';
import { post } from 'aws-amplify/api';
import { DebugService } from '../debug-service/debug.service';
import { ErrorService } from '../error-service/error.service';
import { PartialWarrant } from 'src/app/classes/warrants/partial-warrant/partial-warrant';
import { IntercessorRequest } from 'src/app/classes/requests/intercessor/intercessor-request/intercessor-request';
import { SubmitWarrantPayload } from 'src/app/classes/requests/intercessor/submit-warrant-payload/submit-warrant-payload';
import { LoadCourtsPayload } from 'src/app/classes/requests/intercessor/load-courts-payload/load-courts-payload';
import { UtiltyService } from '../utility-service/utilty.service';
import { Search } from 'src/app/classes/warrants/search/search';
import { ServiceArea } from 'src/app/classes/warrants/returns/service-area/service-area';
import { Warrant } from 'src/app/classes/warrants/warrant/warrant';

@Injectable({
  providedIn: 'root'
})
export class IntercessorService {
  /** Service name */
  private serviceName = 'intercessor-service';

  constructor(
    private debugService: DebugService,
    private errorService: ErrorService,
    private utilityService: UtiltyService,
  ) { }

  //----- Agency -----//
  /**
   * Get the court connections for the agency
   * @param agencyId The agency ID
   * @returns RestApi post response
   */
  public handleGetAgencyCourtConnections = async (agencyId: string) => {
    try {
      const payload: LoadCourtsPayload = {
        agencyId: agencyId
      }
      const intercessorRequest: IntercessorRequest = {
        handler: 'courts',
        data: payload
      }

      const restOperation = post({
        apiName: 'cwApi',
        path: '/intercessor',
        options: {
          body: this.utilityService.primativeCopy(intercessorRequest),
        }
      });

      return await restOperation.response;
    } catch (error) {
      throw this.errorService.passError(`${this.serviceName} - handleGetAgencyCourtConnections`, error);
    }
  }

  //----- Warrant -----//
  /**
   * Submit the warrant to the court
   * @param warrant Warrent to submit
   * @param courtId Court ID
   * @returns RestApi post response
   */
  public handleSubmitWarrantToCourt = async (warrant: PartialWarrant, courtId: string) => {
    try {
      const payload: SubmitWarrantPayload = {
        searchWarrant: warrant,
        submitTo: [courtId]
      }
      const intercessorRequest: IntercessorRequest = {
        handler: 'submit',
        data: payload
      }

      this.debugService.logData(`${this.serviceName} - handleSubmitWarrantToCourt - intercessorRequest`, intercessorRequest);

      const restOperation = post({
        apiName: 'cwApi',
        path: '/intercessor',
        options: {
          body: this.utilityService.primativeCopy(intercessorRequest),
        }
      });

      return await restOperation.response;
    } catch (error) {
      throw this.errorService.passError(`${this.serviceName} - handleSubmitWarrantToCourt`, error);
    }
  }

  /**
   * Serve the warrant to the court
   * @param warrant Warrant to serve
   * @param searches Searches to update
   * @param serviceAreas Service areas created
   * @param courtId Destination court ID
   * @returns RestApi post response
   */
  public handleServeWarrantToCourt = async (warrant: Warrant, searches: Search[], serviceAreas: ServiceArea[], courtId: string) => {
    try {

      const restOperation = post({
        apiName: 'cwApi',
        path: '/intercessor',
        options: {
          body: {
            handler: 'service',
            data: {
              searchWarrant: this.utilityService.primativeCopy(warrant),
              searches: this.utilityService.primativeCopy(searches),
              serviceAreas: this.utilityService.primativeCopy(serviceAreas),
              submitTo: [courtId]
            }
          }
        }
      });

      return await restOperation.response;
    } catch (error) {
      throw this.errorService.passError(`${this.serviceName} - handleServeWarrantToCourt`, error);
    }
  }
}
